import { Section } from '../../components/Section'
import { Jobs } from '../../components/Jobs'

export function Trabalhos() {
 return (
  <Section id="trabalhos" title="Trabalhos" className="py-20">
   <div className="container no-padding">
    <Jobs />
   </div>
  </Section>
 )
}
